module.exports = __webpack_public_path__ + "img/rewolucyjna_books.ef1979f0.png";